__turbopack_context__.v({
  "step": "ExtractAvatar-module__qfkAEq__step",
  "stepDone": "ExtractAvatar-module__qfkAEq__stepDone",
  "stepLabel": "ExtractAvatar-module__qfkAEq__stepLabel",
  "stepNumber": "ExtractAvatar-module__qfkAEq__stepNumber",
  "stepNumberDone": "ExtractAvatar-module__qfkAEq__stepNumberDone",
  "steps": "ExtractAvatar-module__qfkAEq__steps",
});
